import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CreateRecordApiData {
  activeStep: number;
  recordId: string;
  applicantInfo: Record<string, any>;
  recordInfo: Record<string, any>;
  loading: boolean;
  categoryOfIntereset: Record<string, any>[];
  additionalMemberPosition: Record<string, any>[];
}

const initialState: CreateRecordApiData = {
  activeStep: 0,
  recordId: "",
  applicantInfo: {},
  recordInfo: {},
  loading: false,
  categoryOfIntereset: [],
  additionalMemberPosition: [],
};

const createRecordReappointmentSlice = createSlice({
  name: "RecordReappointment",
  initialState,
  reducers: {
    createApplicantRequest: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      state.applicantInfo = { ...state.applicantInfo, ...action.payload };
      state.loading = false;
    },

    createRecordId: (state, action: PayloadAction<string>) => {
      state.recordId = action.payload; // Update the id in the state.loading = false;
    },

    createRecordRequest: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      state.recordInfo = { ...state.recordInfo, ...action.payload };
      state.loading = false;
    },

    resetRecordRequest: (state, action: PayloadAction<Record<string, any>>) => {
      state.recordInfo = {};
      state.loading = false;
    },

    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload; // Update the id in the state
    },

    categoryOfInteresetRequest: (
      state,
      action: PayloadAction<Record<string, any>[]>
    ) => {
      state.categoryOfIntereset = action.payload;
      state.loading = false;
    },

    setAdditionalMemberPosition: (
      state,
      action: PayloadAction<Record<string, any>[]>
    ) => {
      state.additionalMemberPosition = action.payload;
      state.loading = false;
    },

    resetReappointment: () => initialState,
  },
});

export const {
  createApplicantRequest,
  createRecordRequest,
  categoryOfInteresetRequest,
  createRecordId,
  setActiveStep,
  setAdditionalMemberPosition,
  resetReappointment,
} = createRecordReappointmentSlice.actions;
export default createRecordReappointmentSlice.reducer;
